module.exports = __webpack_public_path__ + "img/imagem-02-detalhada-palmeiras-02.e06c7ce0.png";